const mapStateToProps = state => 
     ({
        currentUser: state.security.currentUser,
        dataOP: state.dataOP.dataOP
    });

export default mapStateToProps;
